import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarUtilizadorLayer from "../components/CadastrarUtilizadorLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarUtilizadorPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("utilizador.breadcrumb.create")} />
      <CadastrarUtilizadorLayer />
    </MasterLayout>
  );
};

export default CadastrarUtilizadorPage;
